<template>
  <div class="footer">
    <div class="content">
      <div class="label">
        <div v-for="(item, index) in labelList" :key="index" class="labelItem">
          <img class="searchIcon" :src="item.icon" alt="icon" />
          <span>{{ item.label }}</span>
        </div>
      </div>
      <div class="list-link">
        <div class="list-item">
          <div class="pointer frist_link">
            <span class="handle" @click="$router.push({ name: 'about' })"
              >了解宁东工业超市</span
            >
          </div>
        </div>
        <div class="list-item">
          <div class="pointer frist_link">
            <span class="handle" @click="$router.push({ name: 'contact' })"
              >联系我们</span
            >
          </div>
        </div>
        <div class="list-other">
          <div class="flex-end">
            <div class="customer">
              <div class="txt1">{{ $t("footer.customer") }}</div>
              <div class="txt2">0951-5918508</div>
              <div class="txt3">工作时间：工作日早9:00-晚17:00</div>
              <!-- <div class="btn pointer" @click="consultJump">在线咨询</div> -->
            </div>
            <div>
              <!-- <img
                class="appImg"
                src="@/assets/img/appDownload.png"
                alt="app二维码"
              /> -->
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="mb-12">
        <span class="bold">{{ $t("footer.link") }}：</span>
        <span class="link pointer" v-for="item in linkList" :key="item.linkId"
          ><a :href="item.url" target="_blank" rel="nofollow">{{
            item.name
          }}</a></span
        >
      </div>
      <div>
        <span class="link pointer">
          <a target="_blank" href="http://beian.miit.gov.cn/">
            浙ICP备2023011991号-2
          </a>
        </span>
        <span class="link pointer">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802009779"
          >
            浙公网安备 33010802009779号
          </a>
        </span>
        <span class="link pointer">
          <a target="_blank" href="http://beian.miit.gov.cn"> 工信部网站 </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon1 from '@/assets/img/main/footer/footer_icon_1.png'
import Icon2 from '@/assets/img/main/footer/footer_icon_2.png'
import Icon3 from '@/assets/img/main/footer/footer_icon_3.png'
import Icon4 from '@/assets/img/main/footer/footer_icon_4.png'
import { urlReg } from '@/utils/reg'

export default {
  data () {
    return {
      labelList: [
        {
          label: '品类齐全 正品保证',
          icon: Icon1
        },
        { label: '会员特折 全线低价', icon: Icon2 },
        { label: '多仓直发 极速配送', icon: Icon3 },
        { label: '专属客服 一站服务', icon: Icon4 }
      ], // 标签
      linkList: [
        { name: '宁东能源化工基地管委会', url: 'http://ningdong.nx.gov.cn/' },
        {
          name: '宁东科技服务创新平台',
          url: 'http://119.60.5.197:8081/TechnologyPlatform/'
        },
        { name: '宁东公共仪器服务平台', url: 'http://ndkcpip.cn:8022/yqgxpt/' },
        { name: '宁东公共仪器服务平台', url: 'http://www.smend.cn/index.shtml' }
      ], // 友情链接
      onlineServe: {
        // 在线客服
        phone: ''
      },
      columnList: {
        1: [],
        2: [],
        3: []
      } // 栏目
    }
  },

  mounted () {
    // this.getLinkList()
    // this.getColumnList()
    // this.getOnlineServe()
  },
  methods: {
    // 友情链接公告
    getLinkList () {
      this.$http
        .get('/front/integratedManagement/mgFriendlyLink/showList')
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.linkList = res.data.data || []
          }
        })
    },
    // 栏目
    getColumnList () {
      this.$http
        .get('/front/integratedManagement/mgColumnWindow/homeShowColumns')
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.columnList = res.data.data || []
            Object.keys(this.columnList).forEach((key) => {
              this.columnList[key].sort((a, b) => {
                return a.sort - b.sort
              })
            })
          }
        })
    },
    // 在线客服
    getOnlineServe () {
      this.$http
        .get('/front/integratedManagement/mgOnlineCustmoer/info')
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.onlineServe = res.data.data || {}
            this.$store.commit('setOnlineServe', res.data.data)
          }
        })
    },
    // 跳转栏目链接
    columnRouteHandle (url) {
      if (urlReg.test(url)) {
        window.open(url, '_blank')
      } else {
        this.$router.push({
          name: url
        })
      }
    },
    // 在线咨询
    consultJump () {
      this.$consultJump(this.$store.state.user)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
  padding-top: 32px;
  background-image: linear-gradient(to bottom, #fff, rgba(255, 255, 255, 0)),
    url("~@/assets/img/main/main_bg.png");
  background-size: cover, cover;
  background-position: 0 0, 0% 100%;
  background-repeat: no-repeat, no-repeat;
  min-width: calc(100vw - 56px);
  .label {
    background: #2a54d1;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 24px;
    border-radius: 16px 16px 0 0;
    font-family: Alibaba PuHuiTi;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
    color: #fff;
    .labelItem {
      display: flex;
      align-items: center;
      img {
        margin: 0 8px;
      }
    }
  }
  .content {
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    // align-items: center;
    width: 1190px;
  }

  .line {
    height: 2px;
    margin: 32px 0;
    background: #fff;
  }

  .bold {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 700;
    line-height: 19.6px;
    text-align: left;
    color: #333;
    margin-right: 24px;
    flex-shrink: 0;
  }
  .link {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    text-align: left;

    margin-right: 24px;
    a {
      color: #666;
    }
  }
  .mb-12 {
    margin-bottom: 12px;
  }
  .list-link {
    margin-top: 32px;
    display: flex;
    .list-item {
      width: 200px;
      flex-shrink: 0;
    }
    .list-other {
      width: 800px;
      flex: 1;
    }
  }
  .frist_link {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    color: #333;
    margin-bottom: 12px;
  }
  .list_link {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    color: #666;
    margin-bottom: 12px;
  }
  .flex {
    display: flex;
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
  }
  .appImg {
    width: 142px;
    height: 142px;
    border-radius: 7px;
    margin-left: 20px;
  }
  .customer {
    font-family: Alibaba PuHuiTi;
    color: #666;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .txt1 {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      margin-bottom: 8px;
      margin-top: 16px;
    }
    .txt2 {
      font-family: DIN Black;
      font-size: 24px;
      font-weight: 900;
      line-height: 24px;
      color: #333;
      margin-bottom: 8px;
    }
    .txt3 {
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
      margin-bottom: 8px;
    }
    .btn {
      width: 164px;
      height: 36px;
      cursor: pointer;
      border: 2px solid #2a54d133;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      line-height: 16px;
      color: #2a54d1;
    }
  }
}
</style>
